export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";